import i18n from '../../i18n';

const fe = (key, opts) => i18n.t(`modules.shared.aiAgent.formatDocumentExtraction.${key}`, opts);

const FIELD_LABEL_KEYS = {
  numeroFacture: 'invoice_number',
  date: 'date',
  dateEcheance: 'due_date',
  fournisseur: 'supplier',
  fournisseurId: 'supplier_id',
  designation: 'designation',
  articles: 'items',
  montantHT: 'amount_excl_tax',
  tva: 'vat',
  montantTTC: 'amount_incl_tax',
  notes: 'notes',
  type: 'type',
  montant: 'amount',
  informations: 'information',
};

function resolveFieldLabel(key) {
  const labelKey = FIELD_LABEL_KEYS[key];
  if (labelKey) {
    return fe(`fieldLabels.${labelKey}`);
  }
  return key;
}

export function resolveDocumentTypeForModule(moduleId) {
  if (moduleId === 'achats' || moduleId === 'caisse') return 'bon_commande';
  return 'facture';
}

export function formatExtractedDocumentSummary(data, confidence) {
  if (!data || typeof data !== 'object') {
    return fe('no_structured_data');
  }

  if (data.description) {
    return String(data.description);
  }

  if (data.error && data.rawText) {
    return fe('partial_extraction', {
      text: String(data.rawText).slice(0, 1200),
    });
  }

  const lines = [];
  Object.entries(data).forEach(([key, value]) => {
    if (value == null || value === '' || key === 'error' || key === 'rawText') return;
    const label = resolveFieldLabel(key);
    lines.push(fe('field_line', { label, value }));
  });

  if (lines.length === 0) {
    return fe('no_usable_fields');
  }

  if (confidence != null) {
    lines.push(fe('confidence', { percent: Math.round(confidence * 100) }));
  }

  return lines.join('\n');
}

export function buildAgentMessageFromDocument(userText, extractionSummary) {
  if (userText && extractionSummary) {
    return `${userText}\n\n${fe('extracted_data_header')}\n${extractionSummary}`;
  }
  if (extractionSummary) {
    return fe('document_scanned_prompt', { summary: extractionSummary });
  }
  return userText;
}
